<div class="block-zone" [style.height.px]="blockHeight">
  <header
    class="section-wrapper"
    #header
    [class.collapse]="!expanded && _lastScrollY !== 0"
  >
    <div class="section-content-wrapper entity-indication">
      @if (context?.useHeaderLogoAndStackedText) {
        <span class="overridden-header">
          <div class="unit-display">
            @if (
              dashboardService.dashboardLogoPath &&
              dashboardService.dashboardLogoPath !==
                dashboardService.systemLogoPath &&
              ((!expanded && _lastScrollY !== 0) ||
                dashboardService.dashboardNavigationLevel !==
                  NavigationTier.System ||
                context?.useHeaderLogoAndStackedText)
            ) {
              <a
                class="ribbon institution-logo full-width"
                [attr.title]="logoAltText"
                [routerLink]="[homeUrl]"
              >
                <img
                  [src]="dashboardService.dashboardLogoPath"
                  [alt]="logoAltText + ' - Logo'"
                />
              </a>
            }
            @if (dashboardService.systemLogoPath) {
              <a
                class="ribbon institution-logo system-logo"
                [attr.title]="logoAltText"
                [routerLink]="[homeUrl]"
              >
                <img
                  [src]="dashboardService.systemLogoPath"
                  [alt]="logoAltText + ' - Logo'"
                />
              </a>
            }
            <div class="column">
              @if (
                dashboardService.isSystem &&
                dashboardService.dashboardSiteName &&
                !context?.useHeaderLogoAndStackedText
              ) {
                <div
                  class="site-name"
                  [class.sub-level]="
                    dashboardService.dashboardNavigationLevel !==
                    NavigationTier.System
                  "
                  [class.hideable]="
                    !dashboardService.isSystem ||
                    dashboardService.dashboardNavigationLevel !==
                      NavigationTier.System
                  "
                >
                  <a [attr.title]="logoAltText" [routerLink]="[homeUrl]">
                    <h1 [innerText]="dashboardService.dashboardSiteName"></h1>
                  </a>
                </div>
              }
              @if (
                dashboardService.isSystem && dashboardService.dashboardSiteName
              ) {
                <div class="institution-navigation">
                  @for (
                    unit of dashboardService.displayUnits | async;
                    track unit.id
                  ) {
                    <a
                      tabindex="0"
                      class="click"
                      (click)="dashboardService.selectUnit(unit)"
                      (keyup.enter)="dashboardService.selectUnit(unit)"
                      title="{{
                        unit.abbreviation?.toUpperCase()
                      }} Scholars Showcase"
                      >{{ unit.name }}</a
                    >
                    @if (
                      unit !==
                        (dashboardService.displayUnits | async)[
                          (dashboardService.displayUnits | async).length - 1
                        ] && !context?.useHeaderLogoAndStackedText
                    ) {
                      <span>|</span>
                    }
                  }
                </div>
              }
            </div>
            <div
              class="unit-selection"
              [class.sub-level]="
                dashboardService.dashboardNavigationLevel !==
                NavigationTier.System
              "
            >
              <h1 [innerHTML]="context?.secondarySiteName"></h1>
            </div>
          </div>
        </span>
      }
      @if (!context?.useHeaderLogoAndStackedText) {
        <span>
          <div class="unit-display">
            @if (
              dashboardService.dashboardLogoPath &&
              ((!expanded && _lastScrollY !== 0) ||
                dashboardService.dashboardNavigationLevel !==
                  NavigationTier.System ||
                context?.useCombinedSystemDashboard)
            ) {
              <div
                class="logo-wrapper"
                [ngClass]="{ contact: contactUrl || contactEmail }"
              >
                <a class="ribbon institution-logo" [routerLink]="[homeUrl]">
                  <img
                    [src]="dashboardService.dashboardLogoPath"
                    [alt]="logoAltText + ' - Logo'"
                  />
                </a>
              </div>
            }
            <div class="column">
              @if (
                dashboardService.isSystem &&
                dashboardService.dashboardSiteName &&
                !context?.useCombinedSystemDashboard
              ) {
                <div
                  class="site-name"
                  [class.sub-level]="
                    dashboardService.dashboardNavigationLevel !==
                    NavigationTier.System
                  "
                  [class.hideable]="
                    !dashboardService.isSystem ||
                    dashboardService.dashboardNavigationLevel !==
                      NavigationTier.System
                  "
                >
                  <a [attr.title]="logoAltText" [routerLink]="[homeUrl]">
                    <h1 [innerText]="dashboardService.dashboardSiteName"></h1>
                  </a>
                </div>
              }
              @if (
                dashboardService.isSystem && dashboardService.dashboardSiteName
              ) {
                <div
                  class="institution-navigation"
                  [class.sub-level]="
                    dashboardService.dashboardNavigationLevel !==
                      NavigationTier.System &&
                    !context?.useCombinedSystemDashboard
                  "
                  [class.hideable]="
                    !dashboardService.isSystem &&
                    !context?.useCombinedSystemDashboard
                  "
                >
                  @for (
                    unit of dashboardService.displayUnits | async;
                    track unit.id
                  ) {
                    @if (!context?.useCombinedSystemDashboard) {
                      <a
                        tabindex="0"
                        class="click"
                        (click)="dashboardService.selectUnit(unit)"
                        (keyup.enter)="dashboardService.selectUnit(unit)"
                        title="{{
                          unit.abbreviation?.toUpperCase()
                        }} Scholars Showcase"
                        >{{ unit.name }}</a
                      >
                    }
                    @if (context?.useCombinedSystemDashboard) {
                      <h2>
                        {{ unit.shortName ? unit.shortName : unit.name }}
                      </h2>
                    }
                    @if (
                      unit !==
                        (dashboardService.displayUnits | async)[
                          (dashboardService.displayUnits | async).length - 1
                        ] && !context?.useHeaderLogoAndStackedText
                    ) {
                      <span>|</span>
                    }
                  }
                </div>
              }
            </div>
            <div
              class="unit-selection"
              [class.sub-level]="
                dashboardService.dashboardNavigationLevel !==
                NavigationTier.System
              "
            >
              <h1 [innerHTML]="context?.secondarySiteName"></h1>
            </div>
          </div>
        </span>
      }
      <div class="search-box">
        <div class="search-bar">
          <app-dashboard-search
            (searchInitiated)="search($event)"
            [query]="searchQuery"
            (rawtext)="trackText($event)"
          ></app-dashboard-search>
          @if (
            (dashboardService.unitTypes | async)?.length >= 1 &&
            (!hideDashboardUnitDropdown ||
              dashboardService.dashboardNavigationLevel !==
                NavigationTier.Institution)
          ) {
            <div class="unit-expander" data-qa="unit-dropdown">
              <button
                tabindex="0"
                class="icon-only toggle-menu"
                data-qa="unit-dropdown-toggle"
                (click)="toggleUnitMenu()"
                (keyup.enter)="toggleUnitMenu()"
              >
                <span> {{ toggleMenuText }} </span>
                <fa-icon
                  class="click"
                  [icon]="unitsExpanded ? faCaretUp : faCaretDown"
                  [size]="'lg'"
                ></fa-icon>
              </button>
            </div>
          }
        </div>
        <div class="search-recover">
          <button title="Expand to Search" (click)="expanded = !expanded">
            <fa-icon [icon]="faSearch"></fa-icon>
          </button>
        </div>
      </div>
    </div>
    @if (unitsExpanded) {
      <div
        class="section-content-wrapper unit-section"
        data-qa="unit-dropdown-menu"
        #unitmenu
        [class.unit-section-multiunit]="
          (dashboardService.displayUnitTree | async)?.length > 1
        "
        [style.max-height.px]="
          (dashboardService.displayUnitTree | async).length > 1 ?
            megaMenuHeight + 68
          : null
        "
      >
        @for (
          group of dashboardService.displayUnitTree | async;
          track group.unit?.id ?? $index
        ) {
          @if (group.unit) {
            <div
              class="unit-group-header"
              (click)="dashboardService.selectUnit(group.unit)"
              (keyup.enter)="dashboardService.selectUnit(group.unit)"
              tabindex="0"
            >
              @if (group.unit.logoPath) {
                <img
                  class="unit-group-logo"
                  [src]="group.unit.logoPath"
                  [alt]="group.unit.name + ' Logo'"
                />
              }
              <h3>
                {{
                  context?.useCombinedSystemDashboard ?
                    group.unit.shortName
                  : group.unit.name
                }}
              </h3>
            </div>
          }
          <div class="tab-zone">
            <aa-tabs
              dataQaTag="tab-list"
              [tabDefinitions]="group.tabs"
              (tabSelect)="group.changeView($event)"
            ></aa-tabs>
          </div>
          <div
            class="unit-container"
            [style.max-height.px]="
              (dashboardService.displayUnitTree | async).length > 1 ?
                null
              : megaMenuHeight
            "
          >
            @if (displayAlphabetFilterForUnits) {
              <app-alphabet-filter
                [itemList]="group._children"
                [filterProperty]="'name'"
                (filter)="filterUnits($event)"
              ></app-alphabet-filter>
            }
            <div class="unit-zone" data-qa="unit-dropdown-list">
              @for (unit of group.children; track unit.id) {
                <a
                  class="unit-item"
                  role="button"
                  tabindex="0"
                  (click)="dashboardService.selectUnit(unit)"
                  (keyup.enter)="dashboardService.selectUnit(unit)"
                >
                  {{
                    unit.type === 2 || unit.type === 3 ?
                      unit.shortName
                    : unit.name
                  }}
                </a>
              }
            </div>
          </div>
        }
      </div>
    }
  </header>
</div>
